import React, { useRef } from 'react'

import { useIsHovered } from '@/hooks/useIsHovered'
import { useIsMinWidthMd } from '@/hooks/useIsMinWidthMd'
import { cn } from '@/lib/utils'
import {
  RecommendedPartnerStepElement,
  useRecommendedPartnerSteps,
} from '@/pages/professionalNetworkRelationships/hooks/useRecommendedPartnerSteps'

interface Props {
  stepElement: RecommendedPartnerStepElement
  index: number
}

const RecommendedPartnerTabLink: React.FC<Props> = ({ stepElement, index }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const isHovered = useIsHovered(containerRef)
  const { tabbedStepElements, currentStep, goToStep } =
    useRecommendedPartnerSteps()
  const isMinWidthMd = useIsMinWidthMd()
  const isActive = stepElement.step === currentStep
  const isLastTab = index === tabbedStepElements.length - 1
  const { label, icon, step } = stepElement

  const isHoveredOrActive = isHovered || isActive

  return (
    <div
      ref={containerRef}
      className={cn(
        {
          'border-r': !isLastTab,
        },
        'flex cursor-pointer flex-row items-center border-b md:flex-col',
      )}
      style={{
        backgroundColor: isActive ? 'white' : '#F5F5F5',
        flex: 1,
        padding: isMinWidthMd ? '8px 0' : '7px 6px',
      }}
      onClick={() => goToStep(step)}
    >
      <div
        className="flex items-center justify-center"
        style={{ width: '28px', height: '28px' }}
      >
        <img
          src={isHoveredOrActive ? icon.active : icon.inactive}
          className="max-w-full"
          style={icon.style}
          alt={label}
        />
      </div>

      <div
        className={cn(
          'px-2 font-semibold md:text-center',
          isHoveredOrActive ? 'text-primary' : undefined,
        )}
        style={{ fontSize: '14px', minWidth: '170px' }}
      >
        {label}
      </div>
    </div>
  )
}

export default RecommendedPartnerTabLink
